import { render } from "./AlertRulesEditPage.vue?vue&type=template&id=252c0d07"
import script from "./AlertRulesEditPage.vue?vue&type=script&lang=js"
export * from "./AlertRulesEditPage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__